module.exports = __webpack_public_path__ + "img/vacunas.e35e8f17.png";